module.exports = __webpack_public_path__ + "static/media/limited-time-offer.3a75a026.png";